import { AccessTypeCaptions, AccessTypeEnum } from 'modules/courses/courses/enums/access-type-enum'
import { FormSelectDataType } from 'shared/components'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { CourseBundleAccessType } from '../../types/course-bundle-interface'

export function getCourseBundleAccessTypeDataOptions(
  t: TLocoType,
): FormSelectDataType<CourseBundleAccessType>[] {
  return [
    { id: AccessTypeEnum.fullAccess, caption: t(AccessTypeCaptions[AccessTypeEnum.fullAccess]) },
    {
      id: AccessTypeEnum.drippingContent,
      caption: t(AccessTypeCaptions[AccessTypeEnum.drippingContent]),
    },
  ]
}
